import * as React from "react";
import { useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

// Interface does not seem to be enforced by linter. Was passing defaultIndex as a prop without warning.
// May be because the instance was in JS and not TS(X)
// May also be because I need to set tsconfig to strict and warn about extra properties
interface CarouselTabsProps {
  names: string[];
  selectedIndex: number;
  onChange?: (newIndex: number) => void;
}

export function CarouselTabs({
  names,
  selectedIndex,
  onChange,
}: CarouselTabsProps) {
  const [selectedTab, setSelectedTab] = useState(selectedIndex);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      width="100%"
      sx={{ borderBottom: 1, borderColor: "divider" }}
    >
      <Tabs
        value={selectedTab}
        onChange={handleChange}
        scrollButtons="auto"
        variant="scrollable"
        allowScrollButtonsMobile
        textColor="secondary"
        indicatorColor="secondary"
        aria-label="Featured Lists"
      >
        {names.map((name, index) => (
          <Tab key={index} label={name} />
        ))}
      </Tabs>
    </Box>
  );
}
